<script lang="ts">
    import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
    import IconComponent from "@/components/atoms/Icon.vue";
    import { IconName, PerformanceQASelectors } from "webshop-modules";

    @Component({
        components: {IconComponent}
    })
    export default class SelectionComponent extends Vue {

        @Prop()
        public value!: string;

        @Emit()
        public remove(event: Event): Event {
            return event;
        }

        public readonly iconName: typeof IconName = IconName;
        public readonly PerformanceQASelectors: typeof PerformanceQASelectors = PerformanceQASelectors;
    }
</script>

<template>
    <div class="a-selection a-button -action" v-on:click="remove" :data-qa="PerformanceQASelectors.APPLIED_PROMO_CODE">
        <div class="a-selection__action">
            <IconComponent :icon-id="iconName.Close"/>
        </div>

        <p class="a-selection__item" v-if="value.length">{{ value }}</p>
    </div>
</template>
